import React from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateWorkflowBasicInfo } from '../../../state';
import { useWorkflowValidationContext } from '../../shared';

export const WorkflowNameField: React.FC = () => {
  const dispatch = useAppDispatch();
  const currentWorkflow = useAppSelector((state) => state.workflow.currentWorkflow);
  const { errors, showErrors } = useWorkflowValidationContext();

  if (!currentWorkflow) return null;

  const hasError = showErrors && !!errors.name;

  return (
    <TextField
      label="Workflow Name"
      value={currentWorkflow.name}
      onChange={(e) => dispatch(updateWorkflowBasicInfo({ name: e.target.value }))}
      size="small"
      required
      fullWidth
      placeholder="e.g., High Priority Auto-Assignment"
      error={hasError}
      helperText={hasError ? errors.name : undefined}
    />
  );
};

export default WorkflowNameField;
